let moment = require('moment')
import { classSort, basicSort } from '@/utils'

function getChooseBusCallback(student, busId, studentList, checked = null, availableIds = [], time) {
  let existSubDriverId

  studentList.forEach((studentItem) => {
    if (studentItem.bus_id === busId) {
      existSubDriverId = studentItem.sub_driver_id
    }
  })

  let callback
  let studentIds = []

  if (checked && checked[student.id]) {
    for (let studentId in checked) {
      studentId = parseInt(studentId)
      if (checked[studentId] && availableIds.indexOf(studentId) !== -1) {
        studentIds.push(parseInt(studentId))
      }
    }
  } else {
    studentIds.push(student.id)
  }

  if (existSubDriverId) {
    callback = (studentItem) => {
      if (studentIds.indexOf(studentItem.id) !== -1) {
        studentItem.bus_id = busId
        studentItem.sub_driver_id = existSubDriverId
      }
    }
  } else if (student.sub_driver_id !== null) {
    callback = (studentItem) => {
      if (studentIds.indexOf(studentItem.id) !== -1) {
        studentItem.bus_id = busId
      }

      if (studentItem.bus_id === busId) {
        studentItem.sub_driver_id = student.sub_driver_id
      }
    }
  } else if (typeof time !== 'undefined'){
    callback = (studentItem) => {
      if (studentIds.indexOf(studentItem.id) !== -1) {
        studentItem.time = time
      }
    }
  } else {
    callback = (studentItem) => {
      if (studentIds.indexOf(studentItem.id) !== -1) {
        studentItem.bus_id = busId
      }
    }
  }
  return callback
}

function getChooseTimeCallback(student, studentList, checked = null, availableIds = [], time) {
  let callback
  let studentIds = []

  if (checked && checked[student.id]) {
    for (let studentId in checked) {
      studentId = parseInt(studentId)
      if (checked[studentId] && availableIds.indexOf(studentId) !== -1) {
        studentIds.push(parseInt(studentId))
      }
    }
  } else {
    studentIds.push(student.id)
  }

  callback = (studentItem) => {
    if (studentIds.indexOf(studentItem.id) !== -1) {
      studentItem.time = time

      if (!time) {
        studentItem.bus_id = null
        studentItem.sub_driver_id = null
      }
    }
  }

  return callback
}

export default {

  retrievePickupStudentList (state, payload) {
    state.pickupStudentList = [].concat(payload.studentList)
  },

  retrievePickupStudentListUpdate (state, payload) {
    state.pickupStudentListUpdate = {}
    state.pickupStudentListUpdate[payload.date] = [].concat(payload.studentList)
  },

  retrieveDropStudentList (state, payload) {
    state.dropStudentList = {}
    state.dropStudentList[payload.date] = [].concat(payload.studentList)
  },

  retrieveStudentListNoFilter (state, payload) {
    state.studentListNoFilter = []
    state.studentListNoFilter = [].concat(payload.studentListNoFilter)
  },

  generateDropRoute (state, payload) {
    let currentDate = moment().format('YYYY-MM-DD')

    if (payload.date >= currentDate) {
      let pickupStudentBusList = {}

      state.pickupStudentListUpdate[payload.date].forEach((studentItem) => {
        if (studentItem.bus_id) {
          pickupStudentBusList[studentItem.id] = {
            bus_id : studentItem.bus_id || '',
            sub_driver_id: studentItem.sub_driver_id || '',
            time: studentItem.time || '',
          }
        }
      })
      state.dropStudentList[payload.date].forEach((studentItem) => {
        if (studentItem.can_pick && !studentItem.bus_id && pickupStudentBusList[studentItem.id]) {
          studentItem.bus_id = pickupStudentBusList[studentItem.id].bus_id
          studentItem.sub_driver_id = pickupStudentBusList[studentItem.id].sub_driver_id
          studentItem.time = pickupStudentBusList[studentItem.id].time
        }
      })
      state.dropStudentList[payload.date] = [].concat(state.dropStudentList[payload.date])
      state.isSave = true
    }
  },
  generatePickupRoute(state, payload){
    state.pickupStudentListUpdate = payload
  },

  clearDropRoute (state, payload) {
    let currentDate = moment().format('YYYY-MM-DD')

    if (payload.date >= currentDate) {
      state.dropStudentList[payload.date].forEach((item) => {
        item.bus_id = null
        item.sub_driver_id = null
        item.time = null
      })

      state.dropStudentList[payload.date] = [].concat(state.dropStudentList[payload.date])
      state.isSave = true
    }
  },

  clearPickupRoute (state, payload) {
    let currentDate = moment().format('YYYY-MM-DD')

    if (payload.date >= currentDate) {
      state.pickupStudentListUpdate[payload.date].forEach((item) => {
        item.bus_id = null
        item.sub_driver_id = null
        item.time = null
      })

      state.pickupStudentListUpdate[payload.date] = [].concat(state.pickupStudentListUpdate[payload.date])
      state.isSavePickup = true
    }
  },

  retrieveMasterData (state, payload) {
    state.masterData = Object.assign({}, payload.masterData)
    state.masterData.class_list.sort((before, after) => classSort(before, after))
    state.masterData.place_list.sort((before, after) => basicSort(before, after, 'name'))
    state.masterData.drop_route_list.sort((before, after) => basicSort(before, after, 'name'))
  },

  updatePickupRouteForStudent (state, payload) {
    let student = payload.student
    let busId = parseInt(payload.busId)
    let callback = getChooseBusCallback(student, busId, state.pickupStudentList)

    state.pickupStudentList.forEach(callback)
    state.pickupStudentList = [].concat(state.pickupStudentList)

    state.isSave = true
  },
  updateSave (state, payload) {
    state.isSave = payload.status
  },
  updateSavePickup (state, payload) {
    state.isSavePickup = payload.status
  },

  updateDropRouteForStudent (state, payload) {
    let student = payload.student
    let busId = parseInt(payload.busId)
    let time = payload.time
    let date = payload.date
    let checked = payload.checked
    let availableIds = payload.availableIds
    if (typeof state.dropStudentList[date] !== 'undefined') {
      let callback = getChooseBusCallback(student, busId, state.dropStudentList[date], checked, availableIds, time)

      state.dropStudentList[date].forEach((studentItem) => {
        if (studentItem.time) {
          callback(studentItem)
        }
      })
      state.dropStudentList[date] = [].concat(state.dropStudentList[date])
      state.isSave = true
    }
  },
  updatePickupRouteForStudentUpdate (state, payload) {
    let student = payload.student
    let busId = parseInt(payload.busId)
    let time = payload.time
    let date = payload.date
    let checked = payload.checked
    let availableIds = payload.availableIds
    if (typeof state.pickupStudentListUpdate[date] !== 'undefined') {
      let callback = getChooseBusCallback(student, busId, state.pickupStudentListUpdate[date], checked, availableIds, time)

      state.pickupStudentListUpdate[date].forEach((studentItem) => {
        if (studentItem.time) {
          callback(studentItem)
        }
      })
      state.pickupStudentListUpdate[date] = [].concat(state.pickupStudentListUpdate[date])
      state.isSavePickup = true
    }
  },

  updateDropRouteTimeForStudent (state, payload) {
    let student = payload.student
    let time = payload.time
    let date = payload.date
    let checked = payload.checked
    let availableIds = payload.availableIds
    if (typeof state.dropStudentList[date] !== 'undefined') {
      let callback = getChooseTimeCallback(student, state.dropStudentList[date], checked, availableIds, time)

      state.dropStudentList[date].forEach(callback)
      state.dropStudentList[date] = [].concat(state.dropStudentList[date])
      state.isSave = true
    }
  },
  updatePickupRouteTimeForStudent (state, payload) {
    let student = payload.student
    let time = payload.time
    let date = payload.date
    let checked = payload.checked
    let availableIds = payload.availableIds
    if (typeof state.pickupStudentListUpdate[date] !== 'undefined') {
      let callback = getChooseTimeCallback(student, state.pickupStudentListUpdate[date], checked, availableIds, time)

      state.pickupStudentListUpdate[date].forEach(callback)
      state.pickupStudentListUpdate[date] = [].concat(state.pickupStudentListUpdate[date])
      state.isSavePickup = true
    }
  },

  updateSubDriverForPickupRoute (state, payload) {
    let student = payload.student
    let busId = student.bus_id
    let studentId = student.id
    let subDriverId = parseInt(payload.subDriverId)

    let callback;

    if (!busId) {
      callback = (student) => {
        if (student.id === studentId) {
          student.sub_driver_id = subDriverId
        }
      }
    } else {
      callback = (student) => {
        if (student.bus_id === busId) {
          student.sub_driver_id = subDriverId
        }
      }
    }

    state.pickupStudentList.forEach(callback)
    state.pickupStudentList = [].concat(state.pickupStudentList)
    state.isSave = true
  },

  updateSubDriverForDropRoute (state, payload) {
    let student = payload.student
    let busId = student.bus_id
    let studentId = student.id
    let subDriverId = parseInt(payload.subDriverId)
    let date = payload.date

    if (typeof state.dropStudentList[date] !== 'undefined') {
      let callback;

      if (!busId) {
        callback = (studentItem) => {
          if (studentItem.id === studentId) {
            studentItem.sub_driver_id = subDriverId
          }
        }
      } else {
        callback = (studentItem) => {
          if (studentItem.bus_id === busId) {
            studentItem.sub_driver_id = subDriverId
          }
        }
      }

      state.dropStudentList[date].forEach(callback)
      state.dropStudentList[date] = [].concat(state.dropStudentList[date])
      state.isSave = true
    }
  },
  updateSubDriverForPickupRouteUpdate (state, payload) {
    let student = payload.student
    let busId = student.bus_id
    let studentId = student.id
    let subDriverId = parseInt(payload.subDriverId)
    let date = payload.date

    if (typeof state.pickupStudentListUpdate[date] !== 'undefined') {
      let callback;

      if (!busId) {
        callback = (studentItem) => {
          if (studentItem.id === studentId) {
            studentItem.sub_driver_id = subDriverId
          }
        }
      } else {
        callback = (studentItem) => {
          if (studentItem.bus_id === busId) {
            studentItem.sub_driver_id = subDriverId
          }
        }
      }

      state.pickupStudentListUpdate[date].forEach(callback)
      state.pickupStudentListUpdate[date] = [].concat(state.pickupStudentListUpdate[date])
      state.isSavePickup = true
    }
  },


  updateTimeForDropRoute (state, payload) {
    let student = payload.student
    let time = parseInt(payload.time)
    let date = payload.date

    if (typeof state.dropStudentList[date] !== 'undefined') {
      let callback;

      callback = (studentItem) => {
        if (studentItem.time === student.time) {
          studentItem.time = time
        }
      }

      state.dropStudentList[date].forEach(callback)
      state.dropStudentList[date] = [].concat(state.dropStudentList[date])
      state.isSave = true
    }
  },
  updateTimeForPickupRoute (state, payload) {
    let student = payload.student
    let time = parseInt(payload.time)
    let date = payload.date

    if (typeof state.pickupStudentListUpdate[date] !== 'undefined') {
      let callback;

      callback = (studentItem) => {
        if (studentItem.time === student.time) {
          studentItem.time = time
        }
      }

      state.pickupStudentListUpdate[date].forEach(callback)
      state.pickupStudentListUpdate[date] = [].concat(state.pickupStudentListUpdate[date])
      state.isSavePickup = true
    }
  },


  updateScheduleDetail (state, payload) {
    state.isSave = false
    state.isSavePickup = false
  },

  updateStudentTemplate (state, payload) {
    for (const property in payload.data.dataStudent) {
      for (const property1 in state.studentTemplate.dataStudent) {
        if(!payload.data.dataStudent[property1]){
          payload.data.dataStudent[property1] = state.studentTemplate.dataStudent[property1]
        }
      }
    }
    state.studentTemplate = payload.data
  },
  updateStudentTemplatePickup (state, payload) {
    for (const property in payload.data.dataStudent) {
      for (const property1 in state.pickupStudentTemplate.dataStudent) {
        if(!payload.data.dataStudent[property1]){
          payload.data.dataStudent[property1] = state.pickupStudentTemplate.dataStudent[property1]
        }
      }
    }
    state.pickupStudentTemplate = payload.data
  },

  updateDropRouteTimes (state, payload) {
    state.dropRouteTimes[payload.date] = Object.assign({}, payload.times)
    state.isSave = true
  },
  updatePickupRouteTimes (state, payload) {
    state.pickupRouteTimes[payload.date] = Object.assign({}, payload.times)
    state.isSavePickup = true
  },

  retrieveDropRouteTimes (state, payload) {
    state.dropRouteTimes[payload.date] = Object.assign({}, payload.times)
  },
  retrievePickupRouteTimes (state, payload) {
    state.pickupRouteTimes[payload.date] = Object.assign({}, payload.times)
  }

}
